"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BodyInner = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../../constants/theme");
var _excluded = ["variant", "children", "elementType"];
var BodyInner = exports.BodyInner = _styledComponents["default"].p.withConfig({
  displayName: "Body__BodyInner",
  componentId: "sc-uh1mnt-0"
})(["font-weight:400;", ";white-space:pre-line;margin:0;"], function (_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'regular' : _ref$variant,
    theme = _ref.theme;
  return (0, _theme.getFontCss)(theme.fontSizes.body[variant]);
});
var Body = function Body(_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'regular' : _ref2$variant,
    children = _ref2.children,
    elementType = _ref2.elementType,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(BodyInner, Object.assign({
    as: elementType,
    variant: variant
  }, rest), children);
};
var _default = exports["default"] = Body;
//# sourceMappingURL=Body.js.map